import classNames from "classnames"
import type { ReactNode } from "react"

export interface Props {
  children: ReactNode
  className?: string
}

const FinePrint = ({ children, className }: Props) => {
  return (
    <p
      className={classNames(
        "text-[12px] md:text-[13px] text-gray-300 text-center font-light",
        className
      )}
    >
      {children}
    </p>
  )
}

FinePrint.displayName = "FinePrint"

export { FinePrint }
export default FinePrint
